import { AnswerByCategoryPinSettings } from '@lessonup/pins-shared';
import { styled } from '@lessonup/ui-components';
import React from 'react';
import { PinBackground } from '../components/PinBackground';

export interface AnswerByCategoryPinProps {
  pinSettings: AnswerByCategoryPinSettings;
  isThumb?: boolean;
  children?: React.ReactNode;
}

export const AnswerByCategoryPinComponent: React.FC<AnswerByCategoryPinProps> = ({
  pinSettings,
  isThumb,
  children,
}) => {
  return (
    <AnswerByCategoryWrapper>
      <PinBackground pinType="ANSWER_BY_CATEGORY" settings={pinSettings} isThumb={isThumb} />
      {children}
    </AnswerByCategoryWrapper>
  );
};

const AnswerByCategoryWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
`;
